module.exports = __webpack_public_path__ + "img/b1.6849a543.png";